import styles from './Input.module.css';


const InputElement = props => {
    const { type='text' } = props;
    
    switch (type) {
        case 'text':
            return <input type="text" className={styles.input} {...props} />;

        case 'textarea':
            return <textarea className={styles.textarea} {...props} ></textarea>;

        case 'file':
            return <input type="file" {...props} />

        case 'select':
            return <select className={styles.select} {...props}>
                <option value="">Select...</option>
                {
                    props.options.map((o, i) => (
                        <option key={i} value={o.value}>{o.label}</option>
                    ))
                }
            </select>;
    
        default:
            return <input type="text" className={styles.input} {...props} />;
    }
}


export const FormError = ({ error }) => {
    
    if (!error) return null;
    
    return <span className={styles.error}>{ error }</span>
}


const Input = (props) => {
    
    const { label, variant="", error="" } = props;
    
    return (
        <div className={`${styles.formGroup} ${styles[variant]}`}>
            { label && <label className={styles.label}>{ label }</label> }
            <InputElement {...props} />
            <FormError error={error} />
        </div>
    );
};

export default Input;